import { motion } from 'framer-motion';

/**
 * BreathingCue — a soft, slow-pulsing orb that lives behind the typing area.
 * Cycle: ~4s inhale, ~4s exhale (matches box-breathing without ever labeling it).
 */
export default function BreathingCue({ active = true, dimmed = false }) {
  if (!active) return null;
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 flex items-center justify-center overflow-hidden"
      style={{ zIndex: 0 }}
    >
      <motion.div
        className="breath-orb"
        initial={{ scale: 1, opacity: dimmed ? 0.25 : 0.6 }}
        animate={{
          scale: [1, 1.15, 1],
          opacity: dimmed ? [0.18, 0.32, 0.18] : [0.55, 0.85, 0.55],
        }}
        transition={{
          duration: 8,
          ease: 'easeInOut',
          repeat: Infinity,
        }}
      />
    </div>
  );
}
